<template>
  <div class="main">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link to="/users" v-if="!profileMode" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <h2 v-if="profileMode">Profile</h2>
          <h2 v-else>User Details</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-sm">
          <div class="label-value-unit">
            <div class="micro-label">name</div>
            <div class="value">{{ oneUser.name }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">email</div>
            <div class="value">{{ oneUser.email }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">permissions</div>
            <div class="value">
              <i class="fas fa-users mr-x2" title="user admin" v-if="oneUser.permissions[0] == '1'"></i>
              <i class="fas fa-edit mr-x2" title="editor" v-if="oneUser.permissions[1] == '1'"></i>
              <i class="fas fa-eye mr-x2" title="viewer" v-if="oneUser.permissions[2] == '1'"></i>
              <i class="fas fa-medal" title="first user" v-if="oneUser.permissions[3] == '1'"></i>
            </div>
            <!-- <div class="value">{{ oneUser.permissions }}</div> -->
          </div>
          <div class="label-value-unit">
            <div class="micro-label">profile photo</div>
            <div class="value" v-if="oneUser.userimage">
              <img class="user-image" :src="filePath + 'uploads/profiles/' + oneUser.userimage" >
            </div>
            <div v-else class="value">
              no image uploaded
            </div>
          </div>
        </div>
        <div class="col-sm d-flex flex-column align-items-start">
          <h5 class="mb-x1">Actions</h5>
          <router-link :to="'/profile/edit'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1" v-if="profileMode">
            <i class="fas fa-pen mr-x1"></i>Edit profile
          </router-link>
          <router-link :to="'/users/edit/' + oneUserId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1" v-else>
            <i class="fas fa-pen mr-x1"></i>Edit user
          </router-link>
          <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline mb-x1" @click="verifyDelete = true" v-if="!profileMode && oneUser.permissions[3] != '1'">
            <i class="fas fa-trash mr-x1"></i>Delete this user
          </button>
        </div>
      </div>
    </div>
    <!-- modal town -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDelete }">
      <div class="modal-card">
        <h4>Delete this user?</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteUser()">
          <i class="fas fa-trash mr-x1"></i>Delete this user
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDelete = false">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'cmsdetails',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      oneUserId: '',
      oneUser: {
        'name': '',
        'email': '',
        'permissions': '',
        'userimage': ''
      },
      verifyDelete: false,
      profileMode: false,
      permissionsObj: {
        admin: false,
        editor: false,
        viewer: false,
        first: false
      },
      filePath: apiChoice
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.params.userid) {
        this.oneUserId = this.$route.params.userid
        this.profileMode = false
        this.getOneUser()
      }
      if (this.$route.path === '/profile') {
        this.profileMode = true
        this.oneUserId = this.userData.id
        this.getOneUser()
      }
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.userid) {
      this.oneUserId = this.$route.params.userid
      this.profileMode = false
      this.getOneUser()
    }
    if (this.$route.path === '/profile') {
      this.profileMode = true
      this.oneUserId = this.userData.id
      this.getOneUser()
    }
  },
  methods: {
    getOneUser () {
      axios
        .get(apiChoice + 'api/users/' + this.oneUserId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.oneUser = response.data
          if (!this.oneUser.permissions) {
            this.oneUser.permissions = '0000'
          }
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    deleteUser () {
      axios
        .delete(apiChoice + 'api/users/' + this.oneUserId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          console.log(response)
          this.$router.push({ path: '/users' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}
.user-image{
  max-width: 200px;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
